import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { IOrganisation } from "../../../utilities/Interfaces/OrganisationInterfaces";
import { IUser } from "../../../utilities/Interfaces/UserInterfaces";

/**
 * Authentication state declaration
 */
export interface UserState {
  logedInUser: IUser,
  currentUserSubject: string | null,
  
}

/**
 * Initial authentication state definition
 */
const initialState: UserState = {
    logedInUser: null,
    currentUserSubject: null,
    
};

/**
 * Authentication slice combining actions and reducer
 */
export const userSlice = createSlice({
  name: "user",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetUser: (state) => {
      state.logedInUser = null;
      state.currentUserSubject = null;
    },
    setUser: (state, action: PayloadAction<IUser>) => {
      state.logedInUser = action.payload;
      state.currentUserSubject = null;
    },
    setCurrentUser: (
      state,
      action: PayloadAction<{ user: IUser; subject: string }>
    ) => {
      state.logedInUser = action.payload.user;
      state.currentUserSubject = action.payload.subject;
    },
    
  },
});

export const { resetUser, setUser, setCurrentUser } =
  userSlice.actions;


export default userSlice.reducer;
